// src/api/dashboard.js
import axios from "axios";

const BASE_URL= process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1"

export const fetchDashboardStats = async () => {
    console.log("BASE: "+process.env.REACT_APP_BACKEND_BASE_URL);
  const res = await axios.get(`${BASE_URL}/fetch/dashboard/stats`);
  return res.data;
};
